import createKeys from '../../utilities/createKeys'

const Keys = createKeys('STATEMENT', [])

export default Keys
